/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Adjust_Start_Time_Aria_LabelInputs */

const en_timeline_adjust_start_time_aria_label = /** @type {(inputs: Timeline_Adjust_Start_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust start time`)
};

const fr_timeline_adjust_start_time_aria_label = /** @type {(inputs: Timeline_Adjust_Start_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajuster l'heure de debut`)
};

const de_timeline_adjust_start_time_aria_label = /** @type {(inputs: Timeline_Adjust_Start_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startzeit anpassen`)
};

const it_timeline_adjust_start_time_aria_label = /** @type {(inputs: Timeline_Adjust_Start_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regola l'ora di inizio`)
};

const ru_timeline_adjust_start_time_aria_label = /** @type {(inputs: Timeline_Adjust_Start_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменить время начала`)
};

const es_timeline_adjust_start_time_aria_label = /** @type {(inputs: Timeline_Adjust_Start_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar la hora de inicio`)
};

const zh_cn2_timeline_adjust_start_time_aria_label = /** @type {(inputs: Timeline_Adjust_Start_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调整开始时间`)
};

const ja_timeline_adjust_start_time_aria_label = /** @type {(inputs: Timeline_Adjust_Start_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間を調整する`)
};

const hi_timeline_adjust_start_time_aria_label = /** @type {(inputs: Timeline_Adjust_Start_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारंभ समय समायोजित करें`)
};

const pt_pt2_timeline_adjust_start_time_aria_label = /** @type {(inputs: Timeline_Adjust_Start_Time_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar horário de início`)
};

/**
* | output |
* | --- |
* | "Adjust start time" |
*
* @param {Timeline_Adjust_Start_Time_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_adjust_start_time_aria_label = /** @type {((inputs?: Timeline_Adjust_Start_Time_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Adjust_Start_Time_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_adjust_start_time_aria_label(inputs)
	if (locale === "de") return de_timeline_adjust_start_time_aria_label(inputs)
	if (locale === "it") return it_timeline_adjust_start_time_aria_label(inputs)
	if (locale === "ru") return ru_timeline_adjust_start_time_aria_label(inputs)
	if (locale === "es") return es_timeline_adjust_start_time_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_adjust_start_time_aria_label(inputs)
	if (locale === "ja") return ja_timeline_adjust_start_time_aria_label(inputs)
	if (locale === "hi") return hi_timeline_adjust_start_time_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_adjust_start_time_aria_label(inputs)
	return en_timeline_adjust_start_time_aria_label(inputs)
});